// -------------------------------------------------
// スクロール禁止 + スクロールバー幅のずれ補正
// -------------------------------------------------
let scrollTop = 0;
let lockCount = 0;

function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}

/**
 * モーダル／ドロワー表示時に呼ぶ（即座にロック＋ padding-right）
 * 多重オープンに備え参照カウントする
 */
function lockBodyScroll() {
  lockCount += 1;
  if (lockCount > 1) return;

  const html = document.documentElement;
  const body = document.body;
  const scrollbarWidth = getScrollbarWidth();

  scrollTop = window.scrollY;
  html.style.top = `${scrollTop * -1}px`;
  html.classList.add('is-hidden');

  // body に加え、fixed 要素は CSS 変数 --scrollbar-compensation を参照して補正する
  html.style.setProperty('--scrollbar-compensation', `${scrollbarWidth}px`);
  if (scrollbarWidth > 0) {
    body.style.paddingRight = `${scrollbarWidth}px`;
  }
}

function applyUnlockStyles() {
  const html = document.documentElement;
  const body = document.body;
  const restoreY = scrollTop;

  html.style.top = '';
  html.classList.remove('is-hidden');
  html.style.setProperty('--scrollbar-compensation', '0px');
  body.style.paddingRight = '';

  // CSS の scroll-behavior: smooth が scrollTo に効かないよう一時的に auto へ
  const prevHtmlBehavior = html.style.scrollBehavior;
  const prevBodyBehavior = body.style.scrollBehavior;
  html.style.scrollBehavior = 'auto';
  body.style.scrollBehavior = 'auto';

  window.scrollTo(0, restoreY);

  html.style.scrollBehavior = prevHtmlBehavior;
  body.style.scrollBehavior = prevBodyBehavior;
}

/**
 * 閉じアニメーション終了後などに呼ぶ
 * ロック時に記憶したスクロール位置へ戻す（scroll-behavior: smooth は一時無効化）
 */
function unlockBodyScroll() {
  if (lockCount === 0) return;
  lockCount -= 1;
  if (lockCount > 0) return;

  applyUnlockStyles();
}

/**
 * 参照カウントを無視して必ず解除する（transitionend 欠落・連打開閉向け）
 */
function forceUnlockBodyScroll() {
  if (lockCount === 0 && !document.documentElement.classList.contains('is-hidden')) {
    return;
  }
  lockCount = 0;
  applyUnlockStyles();
}

/** トグル（後方互換） */
function scrollBan() {
  if (document.documentElement.classList.contains('is-hidden')) {
    forceUnlockBodyScroll();
  } else {
    lockBodyScroll();
  }
}

window.getScrollbarWidth = getScrollbarWidth;
window.lockBodyScroll = lockBodyScroll;
window.unlockBodyScroll = unlockBodyScroll;
window.forceUnlockBodyScroll = forceUnlockBodyScroll;
window.scrollBan = scrollBan;
